// extracted by mini-css-extract-plugin
export default {"badge":"WaiverBadge_badge__DRdyd","label":"WaiverBadge_label__-AMbK","icon":"WaiverBadge_icon__bd+J4"};